<template>
  <div>
    <v-autocomplete v-model="selectedItem"
                    @change="select($event)"
                    :items="_options"
                    :placeholder="$t('checklists.add-ellipsis')"
                    :menu-props="{ auto: true }"
                    item-text="name"
                    item-value="id"
    />

    <ob-list :items="_items"
             icon="tasks"
             :no-data-message="$t('checklists.no-checklists')"
             @remove="$emit('remove', $event.id)"
             @select="$emit('select', $event.id)"
    >
      <template v-slot:icon="{ item }">
        <font-awesome-icon :icon="icon(item)" size="lg" />
      </template>

      <template v-slot:default="{ item }">
        <div class="d-flex align-center">
          <div class="flex-grow-1">{{ item.checklist.name }}</div>

          <ob-checkbox v-if="!!requiredToggle"
                      v-model="item.required"
                      :label="$t('checklists.required')"
                      @change="requiredChanged(item, $event)"
                      class="mr-2">
          </ob-checkbox>
          <v-chip label small disabled :title="$t('checklists.version')">v.{{ item.checklist.version }}</v-chip>
        </div>
      </template>
    </ob-list>

  </div>
</template>

<script>
import ObList from '../../shared/components/list'
import ObCheckbox from '../../shared/components/checkbox'

export default {
  name: 'checklists-in',

  props: [ 'items', 'options', 'requiredToggle' ],


  data () {
    return {
      selectedItem: undefined
    }
  },

  computed: {
    _options () {
      return this.options
        .sort((a, b) => a.name.localeCompare(b.name) || Math.sign(a.version - b.version))
        .map(chl => ({ id: chl.id, name: chl.name + ' v.' + chl.version }))
    },

    _items () {
      return this.items.sort((a, b) => a.checklist.name.localeCompare(b.checklist.name) || Math.sign(a.checklist.version - b.checklist.version))
    }
  },

  methods: {
    select (id) {
      this.$emit('change', { checklistId: id })
      this.$nextTick(() => this.selectedItem = null)
    },

    icon (item) {
      return /^OK/i.test(item.summaryStatus) ? 'check-circle' : 'times-circle'
    },

    requiredChanged (item, required) {
      item.required = required
      this.$emit('required', item)
    }
  },

  components: {
    ObCheckbox,
    ObList
  }
}
</script>

<style scoped lang="scss">

</style>

